module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      previewMode: _vm.previewMode
    },
    attrs: {
      "id": "app"
    }
  }, [_c('Topbar', {
    staticClass: "topbar",
    on: {
      "preview": _vm.preview
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('Editor', {
    staticClass: "editor"
  }), _vm._v(" "), _c('Preview', {
    staticClass: "preview"
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "id": "exitPreview"
    },
    on: {
      "click": _vm.exitPreview
    }
  }, [_vm._v("退出预览")]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-427a9fc7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 192
// module chunks = 1